<template>
  <div id="navbar">
    <div class="text-button" v-bind:key="link.text" v-for="link in links">
      <a :href="link.href">{{ link.text }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  props: {
    links: Array
  }
}
</script>

<style scoped>
#navbar {
  width: 100%;
  display: inline-flex;
  margin-bottom: 10px;
  justify-content: space-around;
}

.text-button {
  margin: 20px 20px;
}

/* Phones */
@media only screen
and (max-device-width: 667px)
and (orientation: portrait) {
  #navbar {
    width: 100%;
    margin: 20px 0 20px;
  }
}

</style>